export const siteInfo = {
  name: '韩漫网',
  slogan: '全网最全最新最好看的无删减韩国漫画网站',
  description: '在韩漫网，免费访问全网最全最新最好看的无删减韩国漫画网站，资源齐全画质优良，是您漫画收藏的理想之地。',
  keywords: '全网最全,无删减韩国漫画,韩漫网',
  url: 'https://www.hanmanwang.com',
  email: 'contact@hanmanwang.com',
  phone: '400-888-6666',
  address: '北京市朝阳区望京SOHO T3-A座 2501室',
  year: 2026,
  social: {
    weibo: 'https://weibo.com/hanmanwang',
    wechat: '韩漫网官方',
    qq: '1234567890',
  },
  about: {
    intro: '韩漫网成立于2020年，是国内领先的韩国漫画在线阅读平台。我们致力于为中文读者提供最全面、最新、最高质量的韩国漫画资源。所有漫画均为正版授权，画质优良，更新及时。',
    mission: '让每一位漫画爱好者都能在这里找到心仪的作品，享受纯粹的阅读乐趣。',
    reputation: [
      { stat: '500万+', label: '注册用户' },
      { stat: '2000+', label: '漫画作品' },
      { stat: '99.8%', label: '用户好评率' },
      { stat: '30万+', label: '日活跃读者' },
    ],
  },
  faqs: [
    {
      question: '韩漫网的漫画是否全部免费？',
      answer: '是的，韩漫网所有漫画作品均可免费在线阅读。我们通过广告收入支撑平台运营，为读者提供完全免费的优质漫画资源。',
    },
    {
      question: '漫画多久更新一次？',
      answer: '大部分连载漫画按周更新，热门作品每周更新1-2话。具体更新时间请关注每部漫画的更新日历，我们会在更新后第一时间通知读者。',
    },
    {
      question: '韩漫网的漫画是正版吗？',
      answer: '韩漫网所有漫画均获得韩国版权方的正版授权，我们严格遵守知识产权保护法规，为读者提供合法、优质的阅读体验。',
    },
    {
      question: '如何收藏我喜欢的漫画？',
      answer: '您可以在漫画详情页点击收藏按钮，将喜欢的漫画加入个人收藏夹。后续可在个人中心查看所有收藏作品，并获得更新提醒。',
    },
    {
      question: '支持哪些设备阅读？',
      answer: '韩漫网支持PC端、平板和手机端阅读，适配各种屏幕尺寸。您可以在任何设备上畅享漫画阅读体验，无需下载额外APP。',
    },
  ],
};